import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/rtl.css"; // RTL support for Arabic
import "./lib/console-protection"; // Protect console in production
import { initOptionalSentry } from "./lib/observability/sentry";

initOptionalSentry();

if (import.meta.env.DEV) {
  await import("./lib/expose-supabase.js");
  await import("./lib/debug-vehicles");
}
import i18n from "./lib/i18n/i18n"; // Initialize i18n configuration

// Initialize RTL direction on app startup
const currentLang = i18n.language;
document.documentElement.lang = currentLang;
document.documentElement.dir = currentLang === "ar" ? "rtl" : "ltr";
if (currentLang === "ar") {
  document.body.classList.add("rtl");
  document.body.classList.remove("ltr");
} else {
  document.body.classList.add("ltr");
  document.body.classList.remove("rtl");
}

// StrictMode désactivé en production pour éviter les double-renders
// En développement, il aide à détecter les problèmes mais peut causer des re-renders
const root = ReactDOM.createRoot(document.getElementById("root")!);

// PostHog is now loaded ONLY after user consent via CookieConsent component
// This ensures RGPD compliance - no cookies are set before consent
const appContent = <App />;

root.render(
  import.meta.env.DEV ? (
    <React.StrictMode>
      {appContent}
    </React.StrictMode>
  ) : (
    appContent
  )
);

